// extracted by mini-css-extract-plugin
export default {"title":"title_H1SZg","loginBox":"loginBox_rPwep","wechatLogo":"wechatLogo_oBHSs","wexinBtn":"wexinBtn_czkCW"};